module.exports = __webpack_public_path__ + "img/front length from HPS to waist seam.b0882701.png";